/* global FWP */

const $ = window.jQuery;

export default new class {
  constructor() {
    this.selectors = {
      facets: '.js-facets',
      reset: '.js-facet-reset-button',
      titleBtn: '.js-catalog-search-aside-title-btn',
      filters: '.js-facets-filters',
      facet: '.facetwp-facet',
    };

    this.classes = {
      refreshing: 'is-refreshing',
      active: 'is-active',
      open: 'is-open',
      infoButton: '.js-catalog-search-filter-info-button',
      hasSelections: 'has-selections',
      title: 'is-facet-title',
    };

    this.isSelected = false;
    this.url = new URL(window.location.href);

    $(document).ready(() => {
      this.init();
      this.toggleClearButton();
      this.titleToggleHandler();
    });
  }

  init() {
    this.checkUrlParams();
    this.initRefreshEvent();
    this.initLoadedEvent();
  }

  checkUrlParams() {
    const searchParamsArray = this.url.search.replace('?', '').split('&');
    const newSearchParamsArray = [];

    searchParamsArray.forEach(param => {
      const [, value] = param.split('=');

      if (value) {
        newSearchParamsArray.push(param);
      }
    });

    if (newSearchParamsArray.length) {
      this.url.search = `?${newSearchParamsArray.join('&')}`;
      window.history.pushState({}, '', this.url);
    }
  }

  titleToggleHandler() {
    const titleBtn = $(this.selectors.titleBtn);

    if (titleBtn.length) {
      titleBtn.on('click', e => {
        const btn = $(e.currentTarget);

        if (
          $(e.target).hasClass(this.classes.infoButton) ||
          $(e.target).closest(this.classes.infoButton).length
        ) {
          return;
        }

        btn.parent().toggleClass(this.classes.open);
      });
    }
  }

  initRefreshEvent() {
    let gridItems = $('.b-posts-grid__items');

    $(document).on('facetwp-loaded', () => {
      gridItems = $('.b-posts-grid__items');
      if (gridItems.length) {
        gridItems.removeClass('is-refreshing').addClass('has-loaded');
      }
    });

    $(document).on('facetwp-refresh', () => {
      if (!FWP.loaded) {
        FWP.setHash = () => {};
      }

      if (gridItems.length) {
        gridItems.removeClass('has-loaded').addClass('is-refreshing');
      }

      $(this.selectors.facets).addClass(this.classes.refreshing);
      this.toggleClearButton();
      $(this.selectors.facets).toggleClass(
        this.classes.hasSelections,
        this.isFacetSelected(),
      );

      if (typeof FWP !== 'undefined' && FWP.facets) {
        $.each(FWP.facets, (type, values) => {
          const container = $(`.facetwp-facet-${type}`);
          if (values.length) {
            if (container.length) {
              container.addClass(this.classes.active);
            }
          } else if (container.length) {
            container.removeClass(this.classes.active);
          }
        });
      }
    });
  }

  initLoadedEvent() {
    $(document).on('facetwp-loaded', () => {
      $(this.selectors.facets).removeClass(this.classes.refreshing);

      const filters = $(this.selectors.filters);
      if (filters.length) {
        const activeFilters = filters.find(
          `${this.selectors.facet}.${this.classes.active}`,
        );

        if (activeFilters.length) {
          activeFilters.each((index, facet) => {
            const title = $(facet).prev();

            if (title.length && title.hasClass(this.classes.title)) {
              title.addClass(this.classes.open);
            }
          });
        }
      }
    });
  }

  /* ignore class-methods-use-this */
  isFacetSelected() {
    if (typeof FWP !== 'undefined' && FWP.facets) {
      $.each(FWP.facets, (index, facet) => {
        if (facet.length && !this.isSelected) {
          this.isSelected = true;
        }
      });
    }

    return this.isSelected;
  }

  toggleClearButton() {
    this.isSelected = false;
    $(this.selectors.reset).attr('disabled', !this.isFacetSelected());
  }
}();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/facets.js